import { render, staticRenderFns } from "./PreviewSinglechoiceModule.vue?vue&type=template&id=44526ccc&scoped=true"
import script from "./PreviewSinglechoiceModule.vue?vue&type=script&lang=js"
export * from "./PreviewSinglechoiceModule.vue?vue&type=script&lang=js"
import style0 from "./PreviewSinglechoiceModule.vue?vue&type=style&index=0&id=44526ccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44526ccc",
  null
  
)

export default component.exports